import { waitForElement } from '../base.js'
import { headerLayout } from '../../config.js'
import { initNavigation1 } from './header-1/navigation.js'
import { initNavigation2 } from './header-2/navigation.js'

export const initNavigation = () => {
    addLogo()
    addWidthToMenuLevel2()
    makeOnlyOneSubmenuActive()
    addSocials()
    addContactInfo()

    if (headerLayout === 1) {
        initNavigation1()
    } else if (headerLayout === 2) {
        initNavigation2()
    } else {
        console.error('Invalid header layout:', headerLayout)
    }
}

// Shared functions
function addWidthToMenuLevel2() {
    const container = $('.navigation-wrapper')

    document.documentElement.style.setProperty('--menu-level-2-width', `${container.width()}px`)
}

function addSocials() {
    const socials = $('#footer .social-icons:first').clone()

    waitForElement('#navigation .navigation-in', () => {
        $('#navigation .navigation-in').append(socials)
    })
}

function addContactInfo() {
    const topNavBarClone = $('.top-navigation-bar').clone()
    const elementsToRemove = ['.top-navigation-info-bar', '.top-navigation-tools']

    elementsToRemove.forEach((selector) => {
        topNavBarClone.find(selector).remove()
    })

    topNavBarClone.appendTo('#navigation .navigation-in')
}

function makeOnlyOneSubmenuActive() {
    $('.menu-level-1 > li.ext > a').on('click', function(e) {
        const parentLi = $(this).parent('li.ext');

        if (!parentLi.hasClass('exp')) {
            $('.menu-level-1 > li.ext').not(parentLi).removeClass('exp')
                .children('a').attr('aria-expanded', 'false');
        }
    });
}

function addLogo() {
    const $menu = $('.menu-level-1');
    const $logo = $('<a>', { href: '/', 'class': 'header-logo' });
    const $img = $('<img>', { src: '/user/documents/able-images/categories/logo.svg', alt: 'Logo' });

    $logo.append($img);
    $menu.prepend($logo);
}
